module.exports = __webpack_public_path__ + "img/enhance_after.dc89b497.png";